var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup19967(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.67,
    cy: 31.67,
    r: 31.17,
    fill: "white",
    stroke: "#396DDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.879 33.5676C46.9886 31.7628 47.6929 29.8805 47.6929 28.0097C47.6929 22.4443 43.6905 18.1094 38.53 18.1094C35.6775 18.1094 33.5409 19.4062 32.0701 21.0813C32.0453 21.1064 32.0227 21.1328 32.0002 21.1601C30.5252 19.4472 28.3659 18.1094 25.4696 18.1094C20.3091 18.1094 16.3066 22.4443 16.3066 28.0097C16.3066 29.8756 17.0205 31.759 18.1437 33.5676V33.6379C22.2869 40.3091 32.0002 45.8912 32.0002 45.8912L32.0701 45.8891C32.0701 45.8891 41.7629 40.3329 45.879 33.6379V33.5676Z",
    stroke: "#396DDD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7031 33.5676H23.6844L26.6183 29.3721L30.649 37.1052L35.8666 26.1924L39.4403 33.5676H49.2969",
    stroke: "#396DDD",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup19967);
export default __webpack_public_path__ + "static/media/Group_19967.aa208f53edb856b3783ae5365fa8cf79.svg";
export { ForwardRef as ReactComponent };